//Import
import React from "react";
import styled from "styled-components";
import styles from "./FormInputReadOnly_styles";

// Componente base
const FormInput_base = ({
  type = "text",
  formlabel,
  handleInputBlur,
  handleInputChange,
  name,
  value,
  readOnly = false,
  ...props
}) => {
  return (
    <div {...props}>
      <label htmlFor={formlabel}>{formlabel}</label>
      <input
        type={type}
        name={name}
        value={value ?? ""}
        className="FormInput  transparent-input"
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        required
        autoComplete="off"
        readOnly={readOnly}
      />
    </div>
  );
};
const FormInput = styled(FormInput_base)`
  ${styles}
`;
export default FormInput;
